import {saveStoreInformationApi} from '../api';
import type {SaveInformationRequest} from '../api';

export function saveStoreInformationService(request: SaveInformationRequest) {
  return saveStoreInformationApi(request).toPromise();
}
